var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-skeleton-loader',{staticClass:"mx-auto my-1",attrs:{"max-width":_vm.maxWidth,"transition":"scale-transition","type":"table"}})}
var staticRenderFns = []

export { render, staticRenderFns }